<template>
  <ol class="breadcrumb">
    <li
      class="breadcrumb-item"
      :key="index"
      v-for="(routeObject, index) in routeRecords"
    >
      <span class="active" v-if="isLast(index)">
        {{ routesNames[routeObject.name] }}
      </span>
      <router-link :to="routeObject" v-else>
        {{ routesNames[routeObject.name] }}
      </router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    routeRecords() {
      return this.list.filter((route) => route.name || route.meta.label);
    },
  },
  data() {
    return {
      routesNames: {},
      customNames: {},
    };
  },
  watch: {
    routeRecords: {
      handler(items) {
        items.forEach((item) => {
          if (this.customNames[item.name]) {
            this.routesNames[item.name] = this.customNames[item.name];
          } else {
            this.routesNames[item.name] =
              item.meta && item.meta.label
                ? item.meta.label
                : item.name || null;
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    getName(item) {
      return item.meta && item.meta.label ? item.meta.label : item.name || null;
    },
    isLast(index) {
      return index === this.list.length - 1;
    },
    watchCustomName(key, getterKey) {
      this.$store.watch(
        (state, getters) => getters[getterKey],
        (name) => {
          let names = JSON.parse(JSON.stringify(this.routesNames));
          names[key] = name;
          this.customNames[key] = name;
          this.routesNames = names;
        },
        { immediate: true }
      );
    },
  },
  created() {
    this.watchCustomName("Project", "getCurrentProjectName");
    this.watchCustomName("Submission", "getCurrentSubmissionName");
    this.watchCustomName("Sample", "getCurrentSampleName");
  },
};
</script>
